import authService from 'modules/auth/services';
import cashierService from 'modules/POS/services';
import reportService from 'modules/report/services';
import settingGeneralService from 'modules/settings/general_configuration/services';
import productService from 'modules/settings/product/services';
import staffService from 'modules/settings/staff/services';
import shopService from 'modules/shop/services';
import ticketService from 'modules/tickets/services';
import customerService from 'modules/customer/services';
import giftCardService from 'modules/gift-card/services';
import creditCardService from 'modules/credit_card/services';
import homeService from 'modules/dashboard/services';
import supplierService from 'modules/settings/supplier/services';

const rootReducer = {
  auth: authService.slice.reducer,
  staff: staffService.slice.reducer,
  product: productService.slice.reducer,
  ticket: ticketService.slice.reducer,
  payment: cashierService.reducer,
  settingGeneral: settingGeneralService.slice.reducer,
  shop: shopService.reducer,
  report: reportService.reducer,
  customer: customerService.slice.reducer,
  giftCard: giftCardService.slice.reducer,
  creditCard: creditCardService.reducer,
  home: homeService.slice.reducer,
  supplier: supplierService.slice.reducer,
};

export default rootReducer;
